export const KeyCodes = {
  BACKSPACE: 8,
  SPACE: 32,
  ENTER: 13,
  ESC: 27,
  UP: 38,
  DOWN: 40,
};

export const isItemHighlighted = (highlightedIndex, itemIndex) => highlightedIndex === itemIndex;

export const isItemSelected = (selectedItem, item) => selectedItem && selectedItem.value === item.value;

export const generateIdGenerator = id => idDescriptor => {
  if (!id) return null;

  return `${id}-${idDescriptor}`.replace(/\s/, '-');
};

export const getMaxHeightStyles = (maxHeight, isOpen, isContainer) => {
  if (!maxHeight) return null;

  const mHeight = isContainer ? 'calc(' + maxHeight + ' + 50px)' : maxHeight;

  return {
    maxHeight: isOpen ? mHeight : null,
  };
};

export const itemToString = item => (item ? item.label : '');

export const filterOnHead = (options, filterText = '') => {
  if (!filterText) return options;

  return options.filter(({ label }) => label.toLowerCase().indexOf(filterText.toLowerCase()) === 0);
};

export const filterOnFullString = (options, filterText = '') => {
  if (!filterText) return options;

  return options.filter(({ label }) => label.toLowerCase().includes(filterText.toLowerCase()));
};

export const shouldRenderOptionGroups = options => !Array.isArray(options);



// WEBPACK FOOTER //
// ./src/__utils/selectHelpers.js